import type { EasyNotificationPayload } from "../src/easy-ui/types/easyNotifications";
import type { EasyTimePickerAppPayload } from "../src/easy-ui/types/easyTimePicker";
import type { ShowEasyConfirmPayload } from "../src/easy-ui/types/easyConfirm";
import { EasyPersistentTooltipPayload } from "../src/easy-ui/types/easyPersistentTooltip";
import { EasyAlerts } from "../src/easy-ui/types";

window.EasyUI ||= {};

window.EasyUI.createEasyTimePicker = async (payload: EasyTimePickerAppPayload) => {
  const { createEasyTimePicker } = await import("../src/easy-ui/main");
  window.EasyUI.createEasyTimePicker = createEasyTimePicker;
  createEasyTimePicker(payload);
};

window.EasyUI.showEasyConfirm = async (payload: ShowEasyConfirmPayload) => {
  const { showEasyConfirm } = await import("../src/easy-ui/main");
  window.EasyUI.showEasyConfirm = showEasyConfirm;
  showEasyConfirm(payload);
};

window.EasyUI.showEasyNotification = async (payload: EasyNotificationPayload) => {
  const { showEasyNotification } = await import("../src/easy-ui/main");
  showEasyNotification(payload);
};

window.EasyUI.initEasyIconSet = async (appWrapperId: string) => {
  const { initEasyIconSet } = await import("../src/easy-icons/main");
  initEasyIconSet(appWrapperId);
};

window.EasyUI.createEasyPersistentTooltip = async (payload: EasyPersistentTooltipPayload) => {
  const { createEasyPersistentTooltip } = await import("../src/easy-ui/main");
  createEasyPersistentTooltip(payload);
};

/**
 * For backwards compatibility with existing code that uses `window.showFlashMessage`.
 * Rewrite showFlashMessage from redmine_extensions
 */
window.EASY.schedule.late(() => {
  window.showFlashMessage = async (type: string, messages: string | string[], duration?: number) => {
    const correctType: EasyAlerts = type === "notice" ? EasyAlerts.Success : (type as EasyAlerts);

    (Array.isArray(messages) ? messages : [messages]).forEach(message => {
      window.EasyUI.showEasyNotification({ type: correctType, message, duration });
    });
  };
});
